import React, { Component } from "react";
import "./CannedMessages.scss";
import { getGroup, getUsername } from "../../utils/Common";
import CannedMsgCard from "components/CannedMsgCard/CannedMsgCard";
import Select from "react-select";
import { uepClient } from "uepClient";
import Scrollbars from "components/Scrollbars/Scrollbars";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: 40,
    minHeight: 40,
    font: "normal normal bold 14px/19px Roboto",
    background: "white",
    boxShadow: "0px 3px 6px #00000012",
    border: "none",
    color: "#838EAB",
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    height: 34,
    minHeight: 34,
    letterSpacing: "0px",
    color: "#838EAB",
    font: isFocused
      ? "normal normal bold 14px/19px Roboto"
      : "normal normal normal 14px/19px Roboto",
    backgroundColor: isSelected || isFocused ? "#E6EBF1" : "white",
    border: "none",
  }),
  placeholder: (base) => ({
    ...base,
    text: "Select Category",
    color: "#838EAB",
    font: "normal normal normal 16px/21px Roboto",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    width: 28,
    paddingTop: 0,
    paddingBottom: 0,
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#838EAB",
    font: "normal normal normal 16px/21px Roboto",
  }),
};

export default class CannedMessages extends Component {
  constructor() {
    super();
    this.username = getUsername();
    this.group = getGroup()
    this.state = {
      selectedCategory: "",
      categories: [],
      messages: [],
      showRecentlyUsedMsgs: true,
      recentlyUsedMsgs: [],
    };
  }
  componentDidMount() {
    this.fetchMessageCategories();
    this.fetchRecentlyUsedMessages();
  }

  fetchMessageCategories() {
    uepClient()
      .get(`/canned-message/types/${this.group}`)

      .then((response) => {
        this.setState({ categories: response.data });
      })
      .catch((error) => {
        console.error(
          `An Error occured while fetching canned messages types : ${error.message}`
        );
      });
  }

  fetchCannedMessages(category) {
    if (category) {
      uepClient()
        .get(`/canned-message?type=${category}&group=${this.group}`)
        .then((response) => {
          this.setState({ messages: response.data });
        })
        .catch((error) => {
          console.error(
            `An Error occured while fetching canned messages : ${error.message}`
          );
        });
    } else {
      this.setState({ messages: [] });
    }
  }

  fetchRecentlyUsedMessages() {
    uepClient()
      .get(`/user-canned-message/${this.username}`)
      .then((response) => {
        this.setState({ recentlyUsedMsgs: response.data });
      })
      .catch((error) => {
        console.error(
          `An Error occured while fetching canned messages : ${error.message}`
        );
      });
  }

  renderRecentlyUsedMsgsSection() {
    return (
      <div>
        <div className="recently-used-heading">
          <span>Recently used</span>
        </div>
        <div className="messages-section">
          {this.renderRecentlyUsedMsgsCards()}
        </div>
      </div>
    );
  }

  renderRecentlyUsedMsgsCards() {
    const { recentlyUsedMsgs } = this.state;

    return recentlyUsedMsgs.map((message, index) => (
      <CannedMsgCard key={index} message={message} />
    ));
  }

  renderSelectedCategoryMessages() {
    return (
      <div className="messages-section">{this.renderCannedMessages()}</div>
    );
  }

  renderCannedMessages() {
    const { messages } = this.state;

    return messages.map((message, index) => (
      <CannedMsgCard key={index} message={message} />
    ));
  }

  render() {
    const that = this;
    let options = that.state.categories.map(function (category) {
      return { value: category, label: category };
    });

    return (
      <>
        <div className="canned-msg-container">
          <div className="canned-msgs-listing">
            <div className="msg-category">
              <Select
                isClearable
                options={options}
                styles={customStyles}
                placeholder="Select Category"
                onChange={(selectedOption, triggeredAction) => {
                  if (triggeredAction.action === "clear") {
                    this.setState({
                      selectedCategory: "",
                      showRecentlyUsedMsgs: true,
                    });
                    this.fetchRecentlyUsedMessages();
                  } else {
                    this.setState({
                      selectedCategory: selectedOption.value,
                      showRecentlyUsedMsgs: false,
                    });
                    this.fetchCannedMessages(selectedOption.value);
                  }
                }}
              />
            </div>
            <Scrollbars className="scrollable-msgs-listing">
              {this.state.showRecentlyUsedMsgs
                ? this.renderRecentlyUsedMsgsSection()
                : this.renderSelectedCategoryMessages()}
            </Scrollbars>
          </div>
        </div>
      </>
    );
  }
}
